<!-- <app-sidebar></app-sidebar> -->
<app-hire-sidebar></app-hire-sidebar>
<!-- <app-navbar></app-navbar> -->

<div class="row mx-0">
  <div class="p-3 col-3 mr-1 sidebar-card">
    <app-sidebar-screen></app-sidebar-screen>
  </div>
  <div class="wccard col py-3">
    <div class="">
      <div class="d-flex justify-content-between align-items-center mb-2">
        <span class="f-14 font-weight-600" *ngIf="calledfrom == 'job-create'">Create A Job</span>
        <span class="f-14 font-weight-600" *ngIf="calledfrom == 'job-imports'">Set your <span class="position-relative">Screen<span class="ai-text">AI</span></span>
          <span class="ml-2">Evaluation Criteria {{jobDetails?.atsName == 'Recruiterflow' ? 'Recruiter Flow' :
            jobDetails?.atsName}}</span>
        </span>
      </div>

      <div class="" *ngIf="calledfrom == 'job-create'">
        <div class="row mb-2">
          <div class="col mt-1">
            <span>Job Title<span class="text-danger">*</span></span> <br>
            <input data-testid="auto-app-create-job-input-1" type="text" class="wc-form-control nobg mt-1" placeholder="eg. Software Engineer"
              [formControl]="jobTitlesInput"><br>
              <!-- <span class="f-12 text-danger mt-1" *ngIf="dublicateProjectNameError">Duplicate project name</span>
              <span class="f-12 text-danger mt-1" *ngIf="projectnameSpecialCharError">Special Character Not Allowed</span> -->
              <span class="f-12 text-danger mt-1" *ngIf="jobTitlesInputError">Project Name Required</span>
          </div>
        </div>

        <div class="row mb-2">
          <div class="col mt-1">
            <span>Location</span> <br>
            <input data-testid="auto-app-create-job-input-2"
              (input)="searchLocation($event)"
              type="text"
              placeholder="Enter Location"
              #locationTrigger="matAutocompleteTrigger"
              (keyup.enter)="locationTrigger.closePanel()"
              class="wc-form-control nobg mt-1"
              [formControl]="locationInput"
              [matAutocomplete]="location_auto">
            <mat-autocomplete #location_auto="matAutocomplete" [displayWith]="displayFn" (optionSelected)="onLocationSelected($event)">
              <mat-option *ngFor="let location of locationlist" [value]="location.value">
                {{location.value}}
                <span class="float-right f-12 text-9696 mt-2">{{location.location_type}}</span>
              </mat-option>
            </mat-autocomplete>
          </div>

          <div class="col mt-1">
            <span>Function</span> <br>
            <input data-testid="auto-app-create-job-input-3" type="text" class="wc-form-control nobg mt-1" placeholder="eg. Engineering, Finance"
              [formControl]="industryInput"><br>
          </div>
        </div>

        <div class="row">
          <div class="col mt-4">
            <div>
              <div class="d-flex align-items-center justify-content-between">
                  <span>Enter or Paste a Job Description.<span class="text-danger">*</span></span>

                  <div class="ats-upload-btn d-flex justify-content-center align-items-center pointer ats-btn-width">
                    <div *ngIf="!isUploadedFileCorrect" class="text-center">
                      <div class="pointer" *ngIf="!jdDataLoading">
                        <p class="font-weight-600 text-bluex mb-0">
                          <i class="fa-regular fa-upload mr-1"></i>Upload JD <span class="font-weight-400">(pdf, doc, docx, txt)</span>
                        </p>
                      </div>
                    </div>

                    <input data-testid="auto-app-create-job-input-4" *ngIf="!isUploadedFileCorrect" type="file" #document (change)="uploadFile($event)"
                      accept=".doc,.docx,.txt,.pdf, .dot,.rtf,.odt,.htm,.html">

                    <p *ngIf="jdDataLoading" [ngClass]="{ 'spinner-border text-blue spinner-size': jdDataLoading }"
                      [ngStyle]="{ 'width: 20px; height: 20px;': jdDataLoading }">
                    </p>

                    <div class="text-center d-flex" style="margin-right: 100px;" *ngIf="isUploadedFileCorrect && !jdDataLoading">

                      <img src="../../assets/paperclip.png" style="height: 18px; width: 18px;" />
                      <p class="f-14 font-weight-600 text-webbtree-green text-truncate" style="width: 100px;">{{ uploadedFilename }}</p>
                      <p class="f-14 font-weight-600 text-webbtree-green ml-2 pointer mb-0" (click)="resetFormFields()">Remove</p>
                    </div>

                  </div>
              </div>

              <textarea data-testid="auto-app-create-job-textarea-1" class="wc-form-control nobg mt-1" style="height: 200px;" [formControl]="jdInput"
                placeholder="Enter or Paste a Job Description"></textarea>
              <br>
              <span class="f-12 font-weight-400 text-danger" *ngIf="jdInputError">
                <i class="fa-solid fa-circle-info"></i>
                <span class="text-danger">Enter or Paste a Job Description to proceed further</span>
              </span>

              <div class="d-flex justify-content-between align-items-center">
                <div></div>
                <div>
                  <button data-testid="auto-app-create-job-button-1" class="btn-trms-medium w-100 mt-2"
                    [ngClass]="{ 'bg-gray': showSubmitJdSpinner || !jdInput.value || showCriteria,  'text-center': showSubmitJdSpinner }"
                    (click)="submitJD()" [disabled]="showSubmitJdSpinner || !jdInput.value || showCriteria">
                    <span [ngClass]="{ 'spinner-border text-white spinner-size': showSubmitJdSpinner }"
                      [ngStyle]="{ 'width: 20px; height: 20px;': showSubmitJdSpinner }">
                      {{showSubmitJdSpinner ? '' : 'Submit'}}
                    </span>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="" *ngIf="calledfrom == 'job-imports'">
        <div class="row mt-3">
          <div class="col">
            <p class="imports-job-field">Job Title</p>
            <p class="imports-job-value">{{jobDetails?.data?.name}}</p>
          </div>

          <div class="col">
            <p class="imports-job-field">Location</p>
            <p class="imports-job-value">{{jobDetails?.data?.location}}</p>
          </div>


          <div class="col">
            <p class="imports-job-field">Function</p>
            <p class="imports-job-value">{{jobDetails?.data?.groups?.length ? jobDetails?.data?.groups[0]?.name : 'Not Available'}}</p>
          </div>
        </div>
          <div class="mt-4">
            <p class="imports-job-field">Job Description</p>
            <p *ngIf="!showFullDescription">{{jobDetails?.data?.description?.slice(0, 200)}} <span class="pointer ml-2" style="color: #2E93A1;"
                (click)="viewMoreLessDescription('view-more')">View More</span>
            </p>
            <p *ngIf="showFullDescription">{{jobDetails?.data?.description}} <span class="pointer ml-2" style="color: #2E93A1;"
                (click)="viewMoreLessDescription('view-less')">View Less</span>
            </p>
          </div>
      </div>

      <div class="mt-2" *ngIf="((calledfrom == 'job-create' && showCriteria) || (calledfrom == 'job-imports'))">
        <app-screening-criteria></app-screening-criteria>
      </div>
    </div>
  </div>
</div>
